
import React from 'react';
import { ZoomButtons } from './ZoomButtons';
import { useIsMobile } from '@/hooks/use-mobile';

interface ZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  canZoomIn: boolean;
  canZoomOut: boolean;
  currentLevel: 'macro' | 'meso' | 'micro';
  sliderValue: number;
  onSliderChange: (value: number) => void;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({
  currentLevel,
  onSliderChange
}) => {
  const isMobile = useIsMobile();
  
  // Handle zoom level changes from buttons
  const handleZoomLevelChange = (level: 'macro' | 'meso' | 'micro') => {
    switch (level) {
      case 'macro':
        onSliderChange(0);
        break;
      case 'meso':
        onSliderChange(1);
        break;
      case 'micro':
        onSliderChange(2);
        break;
    }
  };
  
  return (
    <div className="flex items-center gap-2 relative z-30">
      <div className={`flex ${isMobile ? "" : "flex-col"} items-${isMobile ? "center" : "end"} gap-2 relative`}>
        {!isMobile && <span className="text-xs font-medium text-muted-foreground">Zoom Level</span>}
        {isMobile && <span className="text-sm font-medium mr-2">View:</span>}
        <ZoomButtons 
          currentLevel={currentLevel}
          onChangeLevel={handleZoomLevelChange}
        />
      </div>
    </div>
  );
};
